import React, {Component} from 'react';


class ArrowInfo extends Component {
	render(){
		
		if(this.props.rate == 0) {
			return (
					<div className="d-inline-block float-right font-weight-bold text-info">
						<span className="text-muted"></span>
						<span className="icon-circle-small icon-box-xs bg-info-light"><i className="fa fa-fw fa-arrow-right"></i></span>
						<span className="ml-1">{this.props.rate}{this.props.isRate ? "%" :""} </span>
					</div>
			)
		} else if(this.props.rate > 0) {
			return (
					<div className="d-inline-block float-right font-weight-bold text-success">
						<span className="text-muted mb"></span>
						<span className="icon-circle-small icon-box-xs bg-success-light"><i className="fa fa-fw fa-arrow-up"></i></span>
						<span className="ml-1">{this.props.rate}{this.props.isRate ? "%" :""}</span>
					</div>
			)
		} else {
			return (
					<div className="d-inline-block float-right font-weight-bold text-danger">
						<span className="text-muted"></span>
						<span className="icon-circle-small icon-box-xs bg-danger-light"><i className="fa fa-fw fa-arrow-down"></i></span>
						<span className="ml-1">{this.props.rate*-1}{this.props.isRate ? "%" :""}</span>
					</div>
			)
		}
		
	}
}

class Card extends Component {

	constructor(props) {
		super(props);
	}

	render() {

		return (
			<div className="card border-top border-3 border-top-primary">
				<div className="card-body" style={{padding : "11px 20px"}}>
					<h5 className="text-muted mb-4">{this.props.title}</h5>
					<div className="metric-value d-inline-block">
						<h3 className="mb-1">{this.props.value}</h3>
					</div>
					{
						this.props.rate != null ? <ArrowInfo rate={this.props.rate} isRate={this.props.isRate == null ? true : this.props.isRate} /> : null
					}
				</div>
			</div>
		)
		
		
	}

}


export default Card;